import VATDelivery from './VATDelivery'

const vat_delivery = {
  path: 'vat_delivery',
  // sideNav: {
  //   group: 6,
  //   order: 30,
  //   label: 'VAT Delivery',
  //   entityType: 'all',
  //   allowedRole: ['admin', 'sales', 'accounting'],
  //   auth: ['authenticated'],
  // },
  route: {
    index: {
      element: <VATDelivery />,
      allowedRole: 'all',
      entityType: 'all',
      auth: ['authenticated'],
    },
  },
}

export default vat_delivery
